import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnEvidenceTag extends SnModel {
  @Expose()
  public name: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
